/* eslint-disable no-unused-vars */
export enum MediaModes {
  TAB = 'tab',
  IMAGE = 'image',
  CARD_TILES = 'card-tiles',
  TWO_COLUMN_CONTENT_BLOCK = 'two-column-content-block',
  FORM = 'form',
}
